var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26914 15.968C5.97813 15.968 4.02718 15.1626 2.41631 13.5517C0.805436 11.9409 0 9.98991 0 7.6989C0 6.15962 0.389294 4.71878 1.16788 3.37639C1.94647 2.03399 3.13225 0.96008 4.72522 0.154644C5.24428 -0.0601393 5.61568 -0.0511899 5.83941 0.181492C6.06314 0.414173 6.13026 0.745297 6.04077 1.17486C5.98708 1.46124 5.95128 1.74314 5.93338 2.02057C5.91548 2.298 5.90653 2.5799 5.90653 2.86628C5.90653 4.87092 6.60458 6.57129 8.00067 7.96737C9.39676 9.36346 11.0971 10.0615 13.1018 10.0615C13.5492 10.0615 13.943 10.0302 14.2831 9.96754C14.6231 9.9049 14.9095 9.89147 15.1422 9.92727C15.5539 9.90937 15.8179 10.0033 15.9342 10.2092C16.0506 10.415 16.0282 10.7059 15.8671 11.0817C15.2048 12.5315 14.207 13.7083 12.8736 14.6122C11.5401 15.5161 10.0053 15.968 8.26914 15.968Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark-mode.47fce672756e171c3e93d2943dddf27f.svg";
export { ForwardRef as ReactComponent };